var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// fonts.ts
import "@adornis/chemistry/chemistry-lite-element";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design";
import { setGlobalStyle } from "@adornis/chemistry/elements/theming/global-style";
import { fontReset, FontResetElement } from "@adornis/fonts/font-resets";
import { customElement } from "lit/decorators.js";
import { baseFontSize, fontFamily } from "./constants";
fontReset(fontFamily, 1, 500, 1.5, baseFontSize);
setGlobalStyle(() => ({ body: { color: DesignSystem.currentTheme.getValue().colors.on.primary } }));
var fontModifier = (host) => ({
  b: { fontWeight: 500 },
  "&[start]": { textAlign: "start" },
  "&[center]": { textAlign: "center" },
  "&[end]": { textAlign: "end" },
  "&[bold]": { fontWeight: 700 },
  "&[underline], :host([underline]) #actualreset": { textDecoration: "underline" },
  "&[error]": { color: host.colors.secondary }
});
var GEText = class extends FontResetElement {
  constructor() {
    super(...arguments);
    this.styles = () => ({
      // '@media print': { ...fontReset(fontFamily, 1, 400, 1.5, baseFontSize * printFactor) },
      ...fontModifier(this),
      ...fontReset(fontFamily, 1, 400, 1.5, baseFontSize)
    });
  }
};
GEText = __decorateClass([
  customElement("ge-text")
], GEText);
var GEH1 = class extends FontResetElement {
  constructor() {
    super(...arguments);
    this.styles = () => ({
      ...fontModifier(this),
      ...fontReset(fontFamily, 4.8, 700, 1.1, baseFontSize),
      "@media screen and (max-width: 800px)": { ...fontReset(fontFamily, 3, 700, 1.1, baseFontSize) }
    });
  }
};
GEH1 = __decorateClass([
  customElement("ge-h1")
], GEH1);
var GEH2 = class extends FontResetElement {
  constructor() {
    super(...arguments);
    this.styles = () => ({
      ...fontModifier(this),
      ...fontReset(fontFamily, 2.5, 400, 1.5, baseFontSize)
    });
  }
};
GEH2 = __decorateClass([
  customElement("ge-h2")
], GEH2);
var GEH3 = class extends FontResetElement {
  constructor() {
    super(...arguments);
    this.styles = () => ({
      ...fontModifier(this),
      ...fontReset(fontFamily, 1.75, 400, 1.2, baseFontSize)
    });
  }
};
GEH3 = __decorateClass([
  customElement("ge-h3")
], GEH3);
var GEH4 = class extends FontResetElement {
  constructor() {
    super(...arguments);
    this.styles = () => ({
      ...fontModifier(this),
      ...fontReset(fontFamily, 1.25, 400, 1.5, baseFontSize)
    });
  }
};
GEH4 = __decorateClass([
  customElement("ge-h4")
], GEH4);
var GEMini = class extends FontResetElement {
  constructor() {
    super(...arguments);
    this.styles = () => ({
      ...fontModifier(this),
      ...fontReset(fontFamily, 0.8, 400, 1.5, baseFontSize)
    });
  }
};
GEMini = __decorateClass([
  customElement("ge-mini")
], GEMini);
export {
  GEH1,
  GEH2,
  GEH3,
  GEH4,
  GEMini,
  GEText
};
